import { useState, useEffect } from 'react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
const SortingModalCreditsOverviewMain = (props) => {
  const { isMobile } = useMobileSettings();
  const [component, setComponent] = useState(null);

  useEffect(() => {
    const loadComponent = async () => {
      if (isMobile) {
        const module = await import(
          '../MobileComponents/SortingModalCreditsOverviewMob'
        );
        setComponent(() => module.default);
      } else {
        const module = await import(
          '../WebComponents/SortingModalCreditsOverviewWeb'
        );
        setComponent(() => module.default);
      }
    };

    loadComponent();
  }, [isMobile]);

  const LoadedComponent = component;
  return component ? <LoadedComponent {...props} /> : <></>;
};

export default SortingModalCreditsOverviewMain;
